import React, {useState, useEffect} from "react";
import {TextField, DialogContent, DialogActions} from "@material-ui/core";
import {Button, Grid} from "@material-ui/core";
import {Autocomplete} from "@material-ui/lab";
import axios from "axios";
import {Close, Save} from "@material-ui/icons";
import {getCookie} from "../../../components/auth/Helpers";

import "react-dropzone-uploader/dist/styles.css";

const FilterComponent = (props) => {
  const handleChangeAutoComplete = (e, newValue, name) => {
    if (newValue) {
      props.setFilterFormValues((prev) => ({
        ...prev,
        [name]: newValue,
      }));
    } else {
      props.setFilterFormValues((prev) => ({
        ...prev,
        [name]: "",
      }));
    }
  };

  return (
    <>
      <DialogContent dividers>
        <h3>Fridges Types Filter</h3>
      </DialogContent>
      <DialogContent dividers>
        <Grid container spacing={3}>
          <Grid item xs={12} sm={4}>
            <Autocomplete
              id="type"
              options={[
                {id: "Single", name: "Single"},
                {id: "Double", name: "Double"},
              ]}
              value={props.filterFormValues.type || {}}
              getOptionLabel={(option) => (Object.keys(option).length !== 0 ? option.name : "")}
              fullWidth
              onChange={(e, newValue) => handleChangeAutoComplete(e, newValue, "type")}
              renderInput={(params) => <TextField {...params} label="type" name="type" />}
            />
          </Grid>
        </Grid>
      </DialogContent>
      <DialogActions>
        <Button
          variant="outlined"
          color="primary"
          size="large"
          className="btn btn--save"
          onClick={() => props.setOpenDialog(false)}
          startIcon={<Close />}
        >
          Cancel
        </Button>
        <Button
          variant="contained"
          color="primary"
          size="large"
          className="btn btn--save"
          onClick={() => props.fetchData()}
          startIcon={<Save />}
        >
          Save
        </Button>
      </DialogActions>
    </>
  );
};

export default FilterComponent;
